import { useCallback, useSyncExternalStore } from 'react'

export const useMediaQuery = (query: string, fallback = false): boolean => {
  const subscribe = useCallback(
    (callback: () => void) => {
      const mediaQueryList = window.matchMedia(query)

      mediaQueryList.addEventListener('change', callback)

      return () => {
        mediaQueryList.removeEventListener('change', callback)
      }
    },
    [query]
  )

  const getSnapshot = () => {
    return window.matchMedia(query).matches
  }

  const getServerSnapshot = (): boolean => {
    return fallback
  }

  const matches = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  )

  return matches
}

export const useIsDesktop = (fallback = false) =>
  useMediaQuery('(min-width:1024px)', fallback)

export const useIsMobile = () => useMediaQuery('(max-width:1024px)')
